import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { TCommonRowData } from "@ts/common-types";

const allPortfolioIdSlice = createSlice({
    name: "allPortfolioId",
    initialState: { value: [] },
    reducers: {
        updateAllPortfolioId: (
            state,
            action: PayloadAction<TCommonRowData>
        ) => {
            state.value = action.payload;
        },
    },
});

const allSysCampaignIdSlice = createSlice({
    name: "allSysCampaignId",
    initialState: { value: [] },
    reducers: {
        updateAllSysCampaignId: (
            state,
            action: PayloadAction<TCommonRowData>
        ) => {
            state.value = action.payload;
        },
    },
});

const allSysAdgroupIdSlice = createSlice({
    name: "allSysAdgroupId",
    initialState: { value: [] },
    reducers: {
        updateAllSysAdgroupId: (
            state,
            action: PayloadAction<TCommonRowData>
        ) => {
            state.value = action.payload;
        },
    },
});

export const { updateAllPortfolioId } = allPortfolioIdSlice.actions;
export const { updateAllSysCampaignId } = allSysCampaignIdSlice.actions;
export const { updateAllSysAdgroupId } = allSysAdgroupIdSlice.actions;

export const allPortfolioIdReducer = allPortfolioIdSlice.reducer;
export const allSysCampaignIdReducer = allSysCampaignIdSlice.reducer;
export const allSysAdgroupIdReducer = allSysAdgroupIdSlice.reducer;
